import { MediaObject } from 'types'
import validators from './base'
import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'

// Google Business Profile only supports a single photo per post.
// https://developers.google.com/my-business/reference/rest/v4/accounts.locations.localPosts

const googleBusinessProfileContentValidator = (content: string): string[] => {
  const rules = {
    maxCharacters: 1500,
  }

  return validators.validateTextLength(content, rules.maxCharacters)
}

const googleBusinessProfileFileValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minImages: 0,
    maxImages: 1,
  }

  return validators.validateFileCount(files, rules.minImages, rules.maxImages)
}

const googleBusinessProfileDurationValidator = (_files: MediaObject[]): string[] => {
  return []
}

const googleBusinessProfileAspectRatioValidator = (_files: MediaObject[]): string[] => {
  return []
}

const googleBusinessProfileFormatValidator = (_files: MediaObject[]): string[] => {
  return []
}

const googleBusinessProfileVideosCountValidator = (files: MediaObject[]): string[] => {
  return validators.validateVideosCount(files, 0, 1)
}

const googleBusinessProfilePostSettingsValidator = (_settings?: ScheduledPostSettings): string[] => {
  return []
}

const googleBusinessProfileValidators = {
  validateContent: googleBusinessProfileContentValidator,
  validateFiles: googleBusinessProfileFileValidator,
  validateVideosSize: (_files: MediaObject[]) => [],
  validateImagesSize: (_files: MediaObject[]) => [],
  validateVideosDuration: googleBusinessProfileDurationValidator,
  validateVideosAspectRatio: googleBusinessProfileAspectRatioValidator,
  validateVideosFormat: googleBusinessProfileFormatValidator,
  validateVideosCount: googleBusinessProfileVideosCountValidator,
  validatePostSettings: googleBusinessProfilePostSettingsValidator,
}

export default googleBusinessProfileValidators
